import { motion } from "framer-motion";
import {
  LoaderFunction,
  redirect,
  useLoaderData,
  useNavigate,
} from "react-router-dom";

import { ANIMATION_DURATION } from "@/constants/animations.constants";
import { get } from "api";
import FriendShareImg from "assets/images/Referral-Landing-Screen-Image.jpg";
import { Icon } from "atoms/icon/Icon";
import Reward from "atoms/icon/icons/rewards.svg";
import { TextButton } from "atoms/text-button/TextButton";
import { ReferAFriend } from "organisms/refer-a-friend/ReferAFriend";
import { queryClient } from "pages/Root";
import { waitObj } from "toolbox/Promise";

const load = async () => {
  const rewards = queryClient.fetchQuery(["/rewards/referrable"], () =>
    get("/rewards/referrable")
  );

  return waitObj({ rewards });
};

type LoaderData = Awaited<ReturnType<typeof load>>;
export const signUpFriendReferralLoader: LoaderFunction = async () => {
  const data = await load();

  if (!data.rewards.length) {
    return redirect("/home");
  }

  return data;
};

export const SignUpFriendReferralPage = () => {
  const navigate = useNavigate();
  const { rewards } = useLoaderData() as LoaderData;

  return (
    <div className="flex h-full flex-col pt-[40px]">
      <div className="flex flex-col items-center gap-7 overflow-hidden p-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: ANIMATION_DURATION, delay: 0.1 }}
        >
          <Icon svg={Reward} size={"large"} color={"brandColor"} />
        </motion.div>
        <motion.div
          className="text-center font-serif text-h1 text-primary"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: ANIMATION_DURATION, delay: 0.3 }}
        >
          Sharing is caring!
        </motion.div>
        <motion.div
          className="text-center text-body1 text-secondary"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: ANIMATION_DURATION, delay: 0.5 }}
        >
          Send a friend {rewards?.[0].title}!
        </motion.div>
        <motion.div
          className="flex-grow"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: ANIMATION_DURATION, delay: 0.7 }}
        >
          <img className="rounded" src={FriendShareImg} />
        </motion.div>
        <motion.div
          className="absolute inset-x-0 bottom-0 mx-auto flex flex-col items-center gap-[10px] p-4 pb-9 sm:w-[390px]"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: ANIMATION_DURATION, delay: 1.2 }}
        >
          <ReferAFriend buttonOnly={true} />
          <TextButton className="px-3" onClick={() => navigate("/home")}>
            Maybe later
          </TextButton>
        </motion.div>
      </div>
    </div>
  );
};
